import { useDispatch, useSelector } from "react-redux";
import {
  updateCartRequest,
  fetchListCartRequest,
  fetchCountCartRequest,
  updateCartList,
} from "../store/actions";
import { useCallback, useEffect } from "react";
import { UpdateCart } from "../store/types";

export function useCart() {
  const dispatch = useDispatch();

  const handleCart = (id: string) => {
    dispatch(updateCartRequest(id));
  };

  return { handleCart };
}

export function useGetListCart(data?: any) {
  const dispatch = useDispatch();
  const { loading, dataList, lastPage } = useSelector(
    (state: any) => state.Carts || {}
  );
  const user = useSelector((state: any) => state.Auth.userInfo);
  useEffect(() => {
    if (user?.id) {
      dispatch(fetchListCartRequest(data));
    }
  }, [data, dispatch, user]);

  const reLoadList = (data: any) => {
    dispatch(fetchListCartRequest(data));
  };

  const loadMore = useCallback(() => {
    data.page = data.page + 1;
    dispatch(fetchListCartRequest(data));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return { loading, dataList, reLoadList, loadMore, lastPage };
}

export function useUpdateCart() {
  const dispatch = useDispatch();

  const updateCart = (data: UpdateCart, callBack?: () => void) => {
    dispatch(updateCartRequest(data));
    setTimeout(() => {
      callBack?.();
    }, 200);
  };

  return { updateCart };
}

export function useGetCountCart() {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.Auth.userInfo);
  const { loading, countCart } = useSelector((state: any) => state.Carts || {});
  useEffect(() => {
    if (user?.id) {
      dispatch(fetchCountCartRequest());
    }
  }, [dispatch, user]);

  return { loading, countCart };
}


export function useUpdateCartList(listCart?: any) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateCartList(listCart));
  }, [dispatch, listCart]);
}

export function useFetchCountCart() {
  const dispatch = useDispatch();
  const isAuth = useSelector((state: any) => state.Auth.token);
  const _handleLoadCart = () => {
    if (isAuth) {
      dispatch(fetchCountCartRequest());
    }
  };

  return _handleLoadCart;
}
